<template>
    <LandingRates style="padding-top: 0; margin-top: 80px"
      display="flex"
    />

    <section class="container container__mb">
      <UiTariffsInfo/>
    </section>

</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import {useRuntimeConfig} from '#imports';
import {useDirectionStore} from '~/store/direction.store';
import {useStaticStore} from "~/store/static.store";
import LandingRates from '~/modules/Landing/components/LandingRates.vue';

const route = useRoute();
const direction = useDirectionStore();
const isRight = computed(() => direction.isRight);
const {t} = useI18n();

const runtimeConfig = useRuntimeConfig();
const isDflat =
  runtimeConfig.public.vueAppBaseUrl.includes('d-flat.ru');

const activeIndex = ref(0);
const items = ['home_page_forEveryone', 'home_page_forBusiness'];
const toggleWidth = 400;
const toggle = ref(null);
const setActive = (index) => {
  activeIndex.value = index;
}

const isArabic = computed(() => route.fullPath.includes('ar'));

const getToggleWidth = () => {
  if (toggle.value) return toggle.value.offsetWidth;
  return toggleWidth;
}

const staticStore = useStaticStore();
const cardList = staticStore.getTariffsCardList;
const cardListBusiness = staticStore.getTariffsCardListBusiness;

useHead({
  title: `DreamFlat - ${t('plans')}`,
  meta: [
    {
      name: 'description',
      content: `${t('plansMetaDesc')}`,
    },
  ],
});
useSeoMeta({
  ogTitle: `DreamFlat - ${t('Plans')}`,
  description: `${t('plansMetaDesc')}`,
  ogDescription: `${t('plansMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
});
</script>

<style lang="scss">
.section-plans__title {
  font-size: 36px;
}

.pt-96 {
  padding-top: 96px;
}

.pb-403 {
  padding-bottom: 403px;
}

@media screen and (max-width: 600px) {
  .pb-403 {
    padding-bottom: 37px;
  }
  .pt-96 {
    padding-top: 32px;
  }
  .wrapper-tarrifs {
    justify-content: center !important;

    .tarif {
      margin-top: 16px;
      height: auto !important;

      .top {
        margin-bottom: 32px;
      }

      &.mobile {
        display: flex !important;
      }
    }

    .tarif-weight {
      display: none !important;
    }
  }
  .header-to-top {
    width: 1024px !important;
    position: relative !important;
  }
  .functions {
    //overflow-x: visible;
    max-width: 1024px;
    width: 1024px;
  }
  .tarifs {
    //margin-top: 58px!important;
    margin-top: 0 !important;
  }
}

@media screen and (max-width: 850px) {
  .wrapper-tarrifs {
    justify-content: space-around !important;
    gap: 16px;
    margin-top: 24px !important;

    .tarif {
      //padding: 16px;
      .top {
        .descTarif {
          height: auto;
          margin-bottom: 24px;
        }

        .included {
          .desc-tarif {
            font-size: 16px;
          }
        }
      }

      .bottom {
        .hide-in-mobile {
          display: none;
        }
      }
    }
  }
  .tarifs {
    //padding: 0 16px;
    .nameBlock {
      font-size: 24px;
      line-height: 32px;
    }

    .subNameBlock {
      font-size: 18px;
      line-height: 24px;
      margin-top: 8px;
    }
  }
  .table-comparison-price-container {
    min-width: 100%;
    overflow-x: auto;
  }
  .table-comparison-price-container::-webkit-scrollbar {
    display: none;
  }
  .nameBlock {
    font-size: 24px !important;
  }
  .header-to-top {
    .name-function {
      font-size: 18px !important;
    }

    .block-function {
      .name {
        font-size: 18px !important;
      }

      .price {
        font-size: 16px !important;
      }
    }
  }
}

.table-comparison-price-container {
  overflow-x: auto;
}

.functions {
  .column-block {
    display: flex;
    min-width: 1234px;
    transition: all 0.3s ease-out;

    &:hover {
      background-color: #f6f8fd;
      border-radius: 8px;
    }

    .name-function {
      position: relative;
      width: 264px;
      height: 54px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 100%;
        left: 100%;
        border-right: 1px solid #e1e5f0;
      }
    }

    .included {
      position: relative;
      height: 54px;
      width: 194px;
      padding: 0 24px;

      &:last-child {
        &::after {
          border: none;
        }
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 100%;
        left: 100%;
        border-right: 1px solid #e1e5f0;
      }

      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: 10px;

      &.yes {
        background-image: url(assets/tarrifs/tarif-check.svg);
        background-size: 16px;
      }

      &.no {
        background-image: url(assets/tarrifs/tarif-no.svg);
      }
    }
  }
}

.functions {
  .column-block {
    display: flex;
    min-width: 1128px;
    transition: all 0.3s ease-out;

    &:hover {
      background-color: #f6f8fd;
      border-radius: 8px;
    }

    .name-function {
      position: relative;
      width: 264px;
      height: 54px;
      padding: 0 16px;
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
      flex-shrink: 0;

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 100%;
        left: 100%;
        border-right: 1px solid #e1e5f0;
      }
    }

    .included {
      position: relative;
      height: 54px;
      width: 169px;
      padding: 0 16px;
      flex-shrink: 0;

      &:nth-child(4) {
        background-color: #f4f6fd;
        background-clip: content-box;
      }

      &:last-child {
        &::after {
          border: none;
        }
      }

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 100%;
        left: 100%;
        border-right: 1px solid #e1e5f0;
      }

      background-position: center;
      background-repeat: no-repeat;
      display: flex;
      align-items: center;
      justify-content: center;
      background-size: 10px;

      &.yes {
        background-image: url(assets/tarrifs/tarif-check.svg);
        background-size: 16px;
      }

      &.no {
        background-image: url(assets/tarrifs/tarif-no.svg);
      }
    }
  }
}

.header-to-top {
  background-color: white;
  margin-top: 48px;
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 999;
  display: flex;

  &::after {
    position: absolute;
    bottom: -15px;
    left: 0;
    width: 100%;
    height: 15px;
    content: '';
    background: linear-gradient(#ffffff, #00000000);
  }

  & > div {
    padding: 0 16px;
  }

  .name-function {
    width: 264px;
    height: 146px;
    position: relative;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.03em;
    color: #3d424a;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      height: 85%;
      left: 100%;
      border-right: 1px solid #e1e5f0;
    }
  }

  .block-function {
    width: 194px;
    height: 146px;
    position: relative;
    display: flex;
    flex-direction: column;

    .name {
      font-weight: 700;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.03em;
      color: #3d424a;
    }

    .price {
      text-align: center;
      margin-top: 4px;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: $primary;
    }

    .actions {
      //margin-top: 16px;
      margin-top: 28px;

      button {
        width: 100%;
        border-radius: 8px;
        // text-transform: capitalize;
        &.disabled {
          background-color: #f4f6fd !important;
          color: #e1e5f0 !important;
          box-shadow: none;
          text-transform: initial;
        }
      }
    }

    &:last-child {
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 75%;
        left: 100%;
        z-index: 9999;
        border-right: none;
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      height: 75%;
      left: 100%;
      z-index: 9999;
      border-right: 1px solid #e1e5f0;
    }
  }
}

.header-to-top {
  background-color: white;
  margin-top: 48px;
  width: 100%;
  height: 230px;
  position: sticky;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: flex-end;

  &::after {
    position: absolute;
    bottom: -15px;
    left: 0;
    width: 100%;
    height: 15px;
    content: '';
    background: linear-gradient(#ffffff, #00000000);
  }

  & > div {
    padding: 0 16px;
  }

  .name-function {
    width: 264px;
    height: 146px;
    position: relative;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.03em;
    color: #3d424a;
    flex-shrink: 0;

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      height: 85%;
      left: 100%;
      border-right: 1px solid #e1e5f0;
    }
  }

  .overheight {
    height: 210px !important;
    background-color: #f4f6fd;
    background-clip: content-box;
  }

  .block-function {
    width: 169px;
    height: 146px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;

    .bestseller {
      margin-bottom: auto;
      display: flex;
      width: 137px;
      padding: 8px;
      justify-content: center;
      align-items: center;
      border-radius: 8px 8px 0px 0px;
      background: $primary;
      color: #fff;
      /* Launcher/H5 */
      font-family: Segoe UI;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 20px; /* 142.857% */
      letter-spacing: 0.28px;
    }

    .name {
      font-weight: 700;
      height: 64px;
      text-align: center;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.03em;
      color: #3d424a;
    }

    .price {
      text-align: center;
      margin-top: 4px;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: $primary;
    }

    .actions {
      margin-top: 16px;

      button {
        width: 100%;
        border-radius: 8px;
        // text-transform: capitalize;
        &.disabled {
          background-color: #f4f6fd !important;
          color: #e1e5f0 !important;
          box-shadow: none;
          text-transform: initial;
        }
      }
    }

    &:last-child {
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 75%;
        left: 100%;
        z-index: 9999;
        border-right: none;
      }
    }

    &:nth-child(4) {
      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        height: 50%;
        left: 100%;
        z-index: 9999;
        border-right: 1px solid #e1e5f0;
      }
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      height: 75%;
      left: 100%;
      z-index: 9999;
      border-right: 1px solid #e1e5f0;
    }
  }
}

.mt-l {
  //margin-top: 256px;
  margin-top: 128px;
}

.nameBlock {
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 120%;
  text-align: center;
  letter-spacing: 0.03em;
  color: #3d424a;
}

.subNameBlock {
  margin-top: 24px;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.02em;

  color: #3d424a;
}

.wrapper-tarrifs {
  //margin-top: 48px;
  display: flex;
  // justify-content: space-between;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;

  .tarif-weight {
    // margin-top: 24px;
    border: 1px solid #e1e5f0;
    padding: 32px;
    width: 100%;
    letter-spacing: 0.03em;
    background: #f6f8fd;
    border-radius: 16px;
    display: flex;
    gap: 70px;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;

    .triangle {
      position: absolute;
      right: 0;
      top: 0;
    }

    .price {
      width: 256px;
      display: flex;
      margin-right: 32px;
      // flex-direction: row;
      // justify-content: space-between;
      flex-direction: column;
      flex-wrap: wrap;

      .top-card {
        margin-bottom: auto;
        width: 100%;
      }

      .price-action {
        margin-top: 18px;

        button {
          width: 100%;
          border-radius: 8px;
          // text-transform: capitalize;
          font-weight: 600;
        }

        .price-button {
          box-shadow: 0 3px 10px rgb(36 145 231 / 25%);

          border-radius: 8px;
          padding-right: 32px;
          padding-left: 32px;
          font-weight: 600;
          // text-transform: capitalize!important;
          &.disabled {
            background-color: #f4f6fd !important;
            color: #e1e5f0 !important;
            box-shadow: none;
            text-transform: initial;
          }
        }
      }
    }

    .info-tarif {
      // height: 500px;
      width: 608px;

      .desc-tarif {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.03em;
        color: #3d424a;
      }

      ul {
        margin-top: 8px;
        list-style: none;
        margin: 0;
        padding: 0;
        margin-top: 12px;

        &.dot-right {
          li {
            padding-right: 24px;
          }

          li::before {
            content: '•';
            position: absolute;
            color: var(--var-blue-100);
            margin-left: 24px !important;
            left: auto !important;
            right: 0;
            top: 0;
            margin-right: 0px !important;
          }
        }

        li {
          padding-left: 24px;
          margin-bottom: 8px;
          color: #3d424a;
          font-weight: 400;
          font-size: 14px;
          line-height: 140%;
          /* or 22px */
          position: relative;

          letter-spacing: 0.03em;

          .sub-li {
            font-weight: 400;
            font-size: 14px;

            letter-spacing: 0.02em;

            color: #839aaf;
          }
        }

        @include li-before;
      }
    }

    .name-tarif {
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 8px;
      color: #3d424a;
    }

    .price-name {
      font-weight: 700;
      font-size: 42px;
      margin-bottom: 8px;
      color: $primary;
      display: flex;
      align-items: baseline;

      &.price-name-free {
        color: #64686e;
      }

      .monetary {
        font-weight: 400;
        font-size: 14px;
      }
    }

    .price-info {
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      color: #839aaf;
    }

    &.default {
      .name-tarif {
        color: #839aaf;
      }

      .price-name {
        color: #64686e;
      }
    }
  }

  .tarif {
    padding: 16px;
    // width: 325px;
    width: 360px;
    height: 637px;
    background: #f6f8fd;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #e1e5f0;

    &.mobile {
      display: none;
    }

    .included {
      .desc-tarif {
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0.02em;
        color: #3d424a;
      }

      ul {
        margin-top: 8px;
        list-style: none;
        margin: 0;
        padding: 0;
        margin-top: 12px;

        &.dot-right {
          li {
            padding-right: 24px;
          }

          li::before {
            content: '•';
            position: absolute;
            color: var(--var-blue-100);
            margin-left: 24px !important;
            left: auto !important;
            right: 0;
            top: 0;
            margin-right: 0px !important;
          }
        }

        li {
          padding-left: 24px;
          margin-bottom: 8px;
          color: #3d424a;
          font-weight: 400;
          font-size: 14px;
          line-height: 140%;
          /* or 22px */
          position: relative;

          letter-spacing: 0.03em;

          .sub-li {
            font-weight: 400;
            font-size: 13px;

            letter-spacing: 0.02em;

            color: #839aaf;
          }
        }

        li::before {
          content: '•';
          position: absolute;
          color: $primary;
          margin-left: 8px;
          left: 0;
          top: 0;
          margin-right: 13px;
        }
      }
    }

    .bottom {
      width: 100%;

      .price {
        text-align: center;
        width: 100%;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0.03em;
        color: $primary;

        span {
          font-size: 16px;
          font-weight: 400;
        }
      }

      .getStart {
        //margin-top: 8px;
        // margin-top: 28px;
        button {
          width: 100%;
          border-radius: 8px;
          // text-transform: capitalize!important;
          font-weight: 600;
        }

        .price-button {
          box-shadow: 0 3px 10px rgb(36 145 231 / 25%);
          width: 100%;
          border-radius: 8px;
          padding-right: 32px;
          padding-left: 32px;
          font-weight: 600;
          // text-transform: capitalize!important;
          &.disabled {
            background-color: #f4f6fd !important;
            color: #e1e5f0 !important;
            box-shadow: none;
            text-transform: initial;
          }
        }
      }
    }

    .name {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.36px;
      color: #3d424a;

      &.start-name {
        font-style: normal;
        color: #839aaf;
      }
    }

    .descTarif {
      font-weight: 400;
      font-size: 14px;
      line-height: 140%;
      letter-spacing: 0.45px;
      margin-top: 8px;
      color: #839aaf;
      //height: 72px;
    }

    .plans-desc-tariff {
      height: 72px;
    }

    &__weight {
      height: 200px;
      width: 100%;
    }
  }
}

.toggle-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  position: relative;
  padding: 4px;
  box-sizing: border-box;
  border-radius: 12px;
  background: #F6F8FD;
}

.toggle-container__item {
  cursor: pointer;
  padding: 12px 32px 12px 32px;
  z-index: 1;
  transition: 0.3s;

  font-family: Segoe UI;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.02em;
  text-align: center;

  @media (max-width: $md) {
    padding: 12px 16px 12px 16px;
  }
}

.toggle-container__item_active {
  color: white;
  transition: 0.3s;
}

.toggle-container__indicator {
  position: absolute;
  z-index: 0;
  top: 4px;
  left: 8px;
  width: calc(50% - 8px);
  background-color: #2491E7;
  border-radius: 8px;
  height: calc(100% - 8px);
  transition: 0.3s ease-in-out;
}

</style>
